export const RELEASE_LINE = {
  angular: '8.2.x',
  packageVersion: '8.0.0',
  coreVersion: '0.1.1',
  runtimeTarget: 'Angular 8 + Angular CLI',
  docsPath: '/angular-8/'
};
